import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import List from 'components/List/styles';
import { BORDER_BOX } from 'common';

const {
  SPACING,
} = Tokens;
const SPACING_22 = '1.375rem';

const MenuItem = styled(List.ListItemBasic)`
  ${BORDER_BOX}
  padding: ${SPACING.SPACING_4} ${SPACING.SPACING_24};
  height: ${SPACING.SPACING_32};
  &:focus {
    padding: ${SPACING.SPACING_2} ${SPACING_22} ${SPACING.SPACING_2} ${SPACING_22};
  }
  &:hover {
    cursor: pointer;
  }
`;

const MoreButtonItemChecked = styled.div`
  ${List.ListItemChecked} {
    ${BORDER_BOX}
    height: ${SPACING.SPACING_32};
    ${props => (props.RTL || props.$rtl || props.rtl) ? css`padding-right: ${SPACING.SPACING_24}; ` : css`padding-left: ${SPACING.SPACING_24}; `}
    padding-left: ${SPACING.SPACING_24};
    &:focus {
      padding: ${SPACING.SPACING_2} 0.375rem ${SPACING.SPACING_2} 1.375rem;
    }
    &:hover {
      cursor: pointer;
    }
  }
`;

export default {
  MenuItem,
  MoreButtonItemChecked,
};